import { Box } from '@mui/material';
import Table from '../../../core-components/theme/components/Table/Table';
import NoDataView from '../../../globalComponents/NoDataView/NoDataView';
import { columns } from '../helper/tableHelper';
import { useLogbookTable } from '../hooks/useLogbookListTable';

export default function LogbookListTable({ searchString }: any) {
    const { logbooks, lastElementRef, tableContainerRef, queryKey } = useLogbookTable(searchString);
    const tableColumns = columns(queryKey) as any;
    const hasNoData = !logbooks || logbooks.length === 0;

    return (
        <Box ref={tableContainerRef} sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            {hasNoData ? (
                <NoDataView message="No data available" />
            ) : (
                <Table
                    stickyHeader
                    rows={logbooks}
                    columns={tableColumns}
                    lastRowRef={lastElementRef as any}
                />
            )}
        </Box>
    );
}